var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',{class:_vm.classes,attrs:{"variant":_vm.variant,"pressed":_vm.pressed,"to":_vm.getTo},on:{"click":_vm.onButtonClick}},[_c('span',{staticClass:"actionlabel"},[_vm._v(_vm._s(_vm.buttonText))])])}
var staticRenderFns = []

export { render, staticRenderFns }